import { isoZ, z } from 'my-zod'

export const customerOrderImportantInformationModel = z.object({
  id: z.number(),
  outfitterId: z.number(),
  title: z.string().max(256),
  text: z.string().max(1500),
  productIds: z.string().array(),
  createdDate: isoZ.instant(),
  lastModifiedDate: isoZ.instant(),
  deletedDate: isoZ.instant().nullable()
})

export type customerOrderImportantInformationModel = z.infer<typeof customerOrderImportantInformationModel>
